import { render } from "./billingPayment.vue?vue&type=template&id=8516222a"
import script from "./billingPayment.vue?vue&type=script&lang=js"
export * from "./billingPayment.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__